import { NFT } from "./NFT";
import { PiggyClubNftDto } from "../../cityversetycoon/networking/data/responses/piggyclub/PiggyClubNftsDto";

export class NFTPiggyClub extends NFT {
    public readonly multiplier: number;
    public readonly buildingAppliedTo: number;
    public readonly imageURL: string;

    public constructor(nft: PiggyClubNftDto) {
        super({
            id: BigInt(nft.id),
            metadata: null,
            owner: "",
            supply: null,
            tokenURI: null,
            type: nft.type as "ERC721" | "ERC1155"
        });
        this.multiplier = nft.multiplier;
        this.buildingAppliedTo = nft.applyUpToBuildingsAmountOf;
        this.imageURL = nft.imageUrl;
    }
}